import { BrowserRouter, Router } from "react-router-dom";

import history from "infra/helpers/history";
import AntdProvider from "infra/packages/antd";
import ChakraUiProvider from "infra/packages/@chakra-ui";
import ClarityProvider from "infra/packages/clarity";
import { ReactQueryProvider } from "infra/packages/react-query";
import config from "infra/config";
import { QueryParamProvider } from "use-query-params";
import MensagemModalContextProvider from "components/DrawerNovaMensagem/MensagemModalContext";
import GlobalLoading from "components/GlobalLoading";
import AuthProvider from "features/auth/auth.context";
import Pages from "ui/pages";
import MixPanelProvider from "infra/packages/mixpanel";
import { PhotoProvider } from "react-photo-view";
import HotJarProvider from "infra/packages/hotjar";
import colors from "resources/theme/colors";
import Zendesk, { ZendeskAPI } from "react-zendesk";
import { useCurrentAuth } from "features/auth/auth.store";
import { ReactQueryDevtools } from "react-query/devtools";
import { useEffect } from "react";
import "infra/packages/@react-pdf-renderer";
import { ReactRouter5Adapter } from "./infra/packages/query-param-provider";
import { parse, stringify } from "query-string";
import { hideZendeskWidgetForPrint } from "./infra/helpers/hideZendeskWidgetForPrint";
import { RegrasTenantProvider } from "./core/features/tenants/tenants.context";
import ProcessamentoModalProvider from "./ui/components/DrawerProcessamentos/ProcessamentoModalContext";

ZendeskAPI("webWidget", "setLocale", "pt");

const setting = {
  color: {
    theme: colors.primary,
  },
};

function App() {
  const { isLogged } = useCurrentAuth();

  useEffect(() => {
    if (isLogged) {
      setTimeout(() => {
        hideZendeskWidgetForPrint();
      }, 1000);
    }
  }, [isLogged]);

  return (
    <ReactQueryProvider>
      <ClarityProvider>
        <ChakraUiProvider>
          <AntdProvider>
            <BrowserRouter>
              <Router history={history}>
                <QueryParamProvider
                  adapter={ReactRouter5Adapter}
                  options={{
                    searchStringToObject: parse,
                    objectToSearchString: stringify,
                  }}
                >
                  <AuthProvider>
                    <RegrasTenantProvider>
                      <HotJarProvider>
                        <MixPanelProvider>
                          <PhotoProvider>
                            <MensagemModalContextProvider>
                              <ProcessamentoModalProvider>
                                <GlobalLoading />

                                <Pages />

                                {isLogged ? (
                                  <Zendesk
                                    defer
                                    zendeskKey={config.zendeskKey}
                                    {...setting}
                                    onLoaded={() =>
                                      console.log("zendesk is loaded")
                                    }
                                    className="hidden-print"
                                  />
                                ) : null}
                              </ProcessamentoModalProvider>
                            </MensagemModalContextProvider>
                          </PhotoProvider>
                        </MixPanelProvider>
                      </HotJarProvider>
                    </RegrasTenantProvider>
                  </AuthProvider>
                </QueryParamProvider>
              </Router>
              {window.origin.includes("localhost") ? (
                <ReactQueryDevtools />
              ) : null}
            </BrowserRouter>
          </AntdProvider>
        </ChakraUiProvider>
      </ClarityProvider>
    </ReactQueryProvider>
  );
}

export default App;
